import { Shuffler } from 'game-logic';
import { SolitaireDealer } from './solitaire-dealer';

export class LocalDealer implements SolitaireDealer {
  private static CardSet =
    'C1 C2 C3 C4 C5 C6 C7 C8 C9 C10 C11 C12 C13 D1 D2 D3 D4 D5 D6 D7 D8 D9 D10 D11 D12 D13 H1 H2 H3 H4 H5 H6 H7 H8 H9 H10 H11 H12 H13 S1 S2 S3 S4 S5 S6 S7 S8 S9 S10 S11 S12 S13';
  private readonly ids: string[];
  private readonly indexToHash: Map<number, string>;

  constructor(ids: string[]) {
    this.ids = ids;
    this.indexToHash = new Map<number, string>();
  }

  public static makeForSimulator(ids: string[]): LocalDealer {
    return new LocalDealer(ids);
  }

  public static makeRandom(): LocalDealer {
    const deck = LocalDealer.CardSet.split(' ');
    const seed: number = Math.floor(new Date().getTime() / 1000);
    const ids = Shuffler.shuffledDeck(seed, deck);
    return new LocalDealer(ids);
  }

  public static makeForDebug(): LocalDealer {
    const cardSet =
      'C13 H13 S13 D13 C12 H12 S12 D12 C11 H11 S11 D11 C10 H10 S10 D10 C9 H9 S9 D9 C8 H8 S8 D8 C1 D1 H1 S1 C2 D2 H2 S2 C3 D3 H3 S3 C4 D4 H4 S4 C5 D5 H5 S5 C6 D6 H6 S6 C7 D7 H7 S7';
    return new LocalDealer(cardSet.split(' '));
  }

  public static makeForFirstRound(): LocalDealer {
    const cardSet =
      'C7 H3 S8 H8 H7 S5 H11 D8 C6 C13 H2 C12 S11 D10 H5 D9 D13 C9 H13 S10 D5 C3 C10 C4 D6 H9 H10 D2 H6 S2 D4 C5 S13 C1 C2 C8 S6 D12 C11 H12 D7 S9 D1 D3 S7 D11 S1 S12 S3 H4 H1 S4';
    return new LocalDealer(cardSet.split(' '));
  }

  public static makeForTest(): LocalDealer {
    const cardSet =
      'C4 C10 C3 D5 S10 H13 C9 D13 D9 H5 D10 S11 C12 H2 C13 C6 D8 H11 S5 H7 H8 S8 H3 C7 D6 H9 H10 D2 H6 S2 D4 C5 S13 C1 C2 C8 S6 D12 C11 H12 D7 S9 D1 D3 S7 D11 S1 S12 S3 H4 H1 S4';
    return new LocalDealer(cardSet.split(' '));
  }

  public discloseCards(
    indexes: number[],
    gameHash: string,
    _disclosedSecrets: number,
    _existingDeal: boolean,
  ): Promise<string[]> {
    try {
      for (const index of indexes) {
        this.indexToHash.set(index, gameHash);
      }
      return Promise.resolve(indexes.map((index) => this.ids[index]));
    } catch (error) {
      return Promise.reject([]);
    }
  }
}
